/**
 * @param {{
 *   value: string | boolean;
 *   options: Array<{ value: string | boolean; label: string; disabled?: boolean }>;
 *   onChange: (value: string | boolean) => void;
 *   ariaLabel: string;
 *   disabled?: boolean;
 *   className?: string;
 *   role?: 'group' | 'tablist';
 *   optionRole?: 'button' | 'tab';
 * }} props
 */
function SegmentedControl({
  value,
  options,
  onChange,
  ariaLabel,
  disabled = false,
  className = '',
  role = 'group',
  optionRole = 'button',
}) {
  return (
    <div
      className={`floor-plan-mode-toggle${className ? ` ${className}` : ''}`}
      role={role}
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const isActive = value === option.value;
        const optionDisabled = disabled || option.disabled;
        return (
          <button
            key={String(option.value)}
            type="button"
            role={optionRole}
            aria-selected={optionRole === 'tab' ? isActive : undefined}
            aria-pressed={optionRole === 'button' ? isActive : undefined}
            className={`floor-plan-mode-toggle-btn${isActive ? ' floor-plan-mode-toggle-btn--active' : ''}`}
            onClick={() => onChange(option.value)}
            disabled={optionDisabled}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
